import { createAction, props } from '@ngrx/store';

import {
  type CanvasElement,
  type CanvasElementId,
  type SlotId,
} from '@blaze-runtime/engine-domain';
import { type PageInfo } from '@blaze-shared/api-contracts-domain';
import { type Connection, type Workflow } from '@blaze-shared/workflow-domain';

export const copyElement = createAction(
  `[CopyPaste] Copy element`,
  props<{ elementId: CanvasElementId; slotId?: SlotId }>(),
);

export const pasteElement = createAction(`[CopyPaste] Paste element`);
export const pasteElementInto = createAction(
  `[CopyPaste] Paste element Into`,
  props<{ elementId: CanvasElementId; slotId?: SlotId }>(),
);
export const pasteElementFailed = createAction(`[CopyPaste] Paste element Failed`);

export const placeCopiedElements = createAction(
  `[CopyPaste] Place copied elements`,
  props<{
    newContainer: CanvasElement;
    rootElementId: CanvasElementId;
    elements: CanvasElement[];
    connections: Connection[];
    workflows: Workflow[];
    dialogs: PageInfo[];
    slotId?: SlotId;
  }>(),
);
